var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.195,
    height: 26.195,
    viewBox: "0 0 26.195 26.195",
    fill: "#d8271b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.463,9.52l-3.312,3.312L10.84,9.52,9.53,10.848l3.293,3.312L9.53,17.472l1.31,1.31,3.312-3.293,3.312,3.293,1.31-1.31L15.48,14.16l3.293-3.312Z",
    transform: "translate(3.946 3.937)",
    fill: "##d8271b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,5A13.1,13.1,0,1,0,31.2,18.1,13.1,13.1,0,0,0,18.1,5Zm0,24.324A11.227,11.227,0,1,1,29.324,18.1,11.227,11.227,0,0,1,18.1,29.324Z",
    transform: "translate(0 0)",
    fill: "#d8271b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMobile);
export default __webpack_public_path__ + "static/media/close-mobile.b07c4cb3ac5f85820377c8630498f1e1.svg";
export { ForwardRef as ReactComponent };